module.exports = __webpack_public_path__ + "static/media/giuliano_simeone.4c74d3e4.jpg";